<template>
	<v-container class="nav-header" fluid>
		<v-row style="height: inherit">
			<v-col class="px-7" style="height: inherit">
				<v-icon
					@click="handleClick"
					style="font-size: 18px; color: white"
				>
					fas fa-arrow-left
				</v-icon>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'nav-header',

	props: [],
	data: () => ({}),
	methods: {
		isActive(name) {
			return name === this.$router.history.current.name
		},
		handleClick() {
			this.$router.go(-1)
		}
	}
}
</script>

<style lang="scss">
.nav-header {
	background-color: $primary;
	max-width: 480px !important;
	width: 100%;
	position: fixed;
	left: 50%;
	top: 0%;
	transform: translateX(-50%);
	margin: 0 auto;
	z-index: 10;

	.col {
		display: flex;
	}
	.v-icon::after {
		height: 20px;
		width: 20px;
		left: -3px;
		top: 2px;
	}
}
</style>
